import { createContext, useContext } from 'react'

export const PageHeaderActionsContext = createContext(() => {})

export function usePageHeaderActions() {
  return useContext(PageHeaderActionsContext)
}
